<header #mainNavHeader class="fixed-top " >
  <nav
    #mainNav
    class="navbar navbar-expand-lg navbar-dark navbar-expand-md x-container header-gradient"
    [ngClass]="{'header-transparent': isTransparent && !isScroll && !forceOpaque}"
  >
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/home" translate>
        <img
          src="/assets/pollstar_logo.svg"
          alt=""
          style="height: 2rem;"
        >
      </a>

      <button
        class="navbar-toggler d-flex d-md-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        #navbarToggler
      >
        <span ><i class="fas fa-bars"></i></span>
      </button>

      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        style="
          position: absolute;
          transition:none!important;
          top: 100px;
          left: 0;
        "
        (click)="toggleNavbar()"
      >
        <ul class="navbar-nav navabar-menu__left ml-auto color-white">

          <!-- Admin links-->
          <ng-container *ngIf="role === 'staff' || role === 'admin'">
            <a
              class="nav-item nav-link link-button"
              routerLink="/dashboard/admin/survey"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span translate>Survey</span>
            </a>

            <a
              class="nav-item nav-link link-button"
              routerLink="/dashboard/admin/participants"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span translate>Partecipanti</span>
            </a>
          </ng-container>

          <!-- User Links-->
          <ng-container *ngIf="role === 'user'">
            <a
              class="nav-item nav-link link-button"
              routerLink="/dashboard/participant/home"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span>Sondaggi</span>
            </a>

            <a
              class="nav-item nav-link link-button"
              routerLink="/dashboard/participant/reward/available"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span translate>Premi</span>
            </a>
          </ng-container>


          <!-- Public links-->
          <ng-container *ngIf="!role">
            <a
              class="nav-item nav-link link-button"
              routerLink="/tutorial"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span>Come Funziona</span>
            </a>

            <a
              class="nav-item nav-link link-button"
              [routerLink]="['reward']"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
            >
              <span>Premi</span>
            </a>

            <a
              class="nav-link btn btn-pollstar btn-pollstar-large btn-outline-white"
              routerLink="/registration"
              [queryParams]="{mode:'registration'}"
            >
              <span>Accedi o Registrati</span>
            </a>
          </ng-container>


          <!-- DROPDOWN -->
          <li class="nav-item dropdown nav-link link-button" *ngIf="isUserAuthenticated()">
            <a
              class="nav-link link-button dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Account
            </a>

            <ul class="dropdown-menu user-dropdown" aria-labelledby="navbarDropdown">

              <span class="dropdown-header">
                <span class="color-dark">{{
                  first_name || username || role
                }}</span>
              </span>

              <div class="dropdown-divider"></div>

              <span class="dropdown-item" *ngIf="role === 'user'">
                <a

                  class="color-dark"
                  [routerLink]="['/dashboard', 'participant', 'reward', 'obtained']"
                >I tuoi premi</a>
              </span>

              <span
                class="dropdown-item color-secondary"
                *ngIf="!!participant_id"
              >
                  <a
                    [routerLink]="['/dashboard', 'participant', 'detail']"
                  >Le tue informazioni</a>
              </span>

              <button class="dropdown-item" (click)="logout()" translate>
                <span>Logout</span>
              </button>

            </ul>
          </li>
          <!-- END DROPDOWN-->
        </ul>
      </div>
    </div>
  </nav>

  <div class="sub-nav" *ngIf="role === 'staff' || role === 'admin'">
    <ng-container>
      <a
        class="nav-item nav-link link-button"
        href="/admin"
        target="_blank"
      >
        <span translate><i class="fab fa-python"></i> Django</span>
      </a>

      <a
        class="nav-item nav-link link-button"
        [href]="configuration?.limesurveyUrl+'/admin'"
        target="_blank"
      >
        <span translate><i class="fas fa-check-circle"></i> Limesurvey</span>
      </a>
    </ng-container>

    <!-- SuperAdmin links-->
    <ng-container *ngIf="role === 'admin'">
      <a
        class="nav-item nav-link link-button"
        routerLink="/dashboard/admin/pixel-test"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
      >
        <!--              <span translate><i class="fab fa-facebook"></i>&nbsp;Pixel</span>-->
        <span translate><i class="fas fa-code"></i>&nbsp;Test</span>

      </a>

    </ng-container>
  </div>

  <app-flash-message></app-flash-message>
</header>

<app-nav-spacer *ngIf="!noSpacer"></app-nav-spacer>












